import React from 'react';

import './dashboard.css';

/**
 * The two cells the three order tables genuinely share.
 *
 * `/dashboard` renders orders three times: the seller's own orders, the buyer's
 * order history, and the admin's all-orders table (which lives in this
 * directory tree but is mounted by `/admin-dashboard`). They are three
 * different queries against three different endpoints and they are NOT one
 * component, but the cells below were copy-pasted into all three and are.
 *
 * Anything with a real visual identity comes from the library; this is
 * arrangement only.
 */

/**
 * The items cell. Capped, because one order with nine cards in it must not turn
 * a 48px row into a 300px one, and the drawer lists every line anyway.
 */
export function OrderItemsCell({ items = [], max = 3 }) {
  if (!Array.isArray(items) || items.length === 0) return 'No items';

  const shown = items.slice(0, max);
  const hidden = items.length - shown.length;

  return (
    <span className="dsa-dash__items">
      {shown.map((item, index) => (
        <span key={`${item.card || item.card_name || 'item'}-${index}`}>
          {item.card || item.card_name || 'Unknown card'} &times;{item.quantity || 1}
        </span>
      ))}
      {hidden > 0 ? (
        <span className="dsa-dash__items-more">
          and {hidden} more {hidden === 1 ? 'card' : 'cards'}
        </span>
      ) : null}
    </span>
  );
}

/**
 * Order ids are UUIDs and the tables have always shown the first segment. That
 * is a real decision, not a truncation bug: the full id is in the drawer, and a
 * 36-character monospace column would crowd out the cards themselves.
 */
export function shortOrderId(orderId) {
  return String(orderId || '').split('-')[0] || 'Unknown';
}

/**
 * Every order total the API sends is either a number or a string that already
 * carries the `R`. Both have to end up as one Rand string and neither may ever
 * become a dollar amount, so the parse lives here once.
 */
export function parseRand(value) {
  if (typeof value === 'number') return value;
  if (value == null) return 0;
  const parsed = parseFloat(String(value).replace('R', '').replace(/\s/g, '').trim());
  return Number.isFinite(parsed) ? parsed : 0;
}
